export default __webpack_public_path__ + "static/media/trust-icon.b50de8c2.svg";